import { nanoid } from 'nanoid/non-secure';
import { mmkv } from '@/storage/mmkv';

const KEY = 'anon_device_id';

/** Stable per-install anonymous id (sent as x-device-id to the LLM proxy). */
export function getDeviceId(): string {
  let id = mmkv.getString(KEY);
  if (!id) {
    id = `dev_${nanoid()}`;
    mmkv.setString(KEY, id);
  }
  return id;
}

/** Dev-only: forget the device id so the anonymous funnel can be replayed. */
export function resetDeviceId(): void {
  mmkv.delete(KEY);
}
